import { insertTrackEvent } from './common.js';

const trackHeaderEvent = icon => {
	insertTrackEvent({
		category: 'Header',
		action: `Click - ${icon}`,
		label: ''
	});
};

export default trackHeaderEvent;
